/**
 * Delte timepris-formler for prosjekter (VIB-1724).
 *
 * Begge er dekningsbidrag per time, IKKE omsetning per time. Prosjektlista og
 * prosjektkortet MÅ bruke disse så de ikke drifter fra hverandre — tidligere
 * delte lista kontraktssum på timer mens kortet delte bruttofortjeneste, så
 * samme kolonnenavn viste to helt ulike tall.
 *
 * Forankret i docs/kpi-source-of-truth.md (reell timepris er Erik-låst
 * 2026-05-15: bf_actual / alle loggede timer).
 */

type Kr = number | null | undefined;

/**
 * Est. timepris = BF estimert / solgte (budsjetterte) timer.
 * Hvor mye dekningsbidrag hver solgt time skal gi ved leveranse på budsjett.
 */
export function estimertTimepris(bfEstimated: Kr, timerSolgt: number): number | null {
  const bf = Number(bfEstimated ?? 0);
  if (bf <= 0 || timerSolgt <= 0) return null;
  return bf / timerSolgt;
}

/**
 * Live/reell timepris = BF reell / alle loggede timer.
 * Faktisk dekningsbidrag per time brukt. Alle loggede timer teller (også
 * internt arbeid), så overforbruk drar timeprisen ned i stedet for å skjules.
 */
export function reellTimepris(bfActual: Kr, timerBrukt: number): number | null {
  const bf = Number(bfActual ?? 0);
  if (bf <= 0 || timerBrukt <= 0) return null;
  return bf / timerBrukt;
}
